import React, { useEffect, useState } from "react";
import { BadgeVariant, StatusBadgeCheckbox } from "../common/status-badge/StatusBadgeCheckbox";
import DialogBox, { IDialogBoxProps } from "../common/dialogbox/DialogBox";
import ErrorDialogBox, { IOKDialogBoxProps } from "../common/dialogbox/ErrorDialogBox";
import { BadgeType, IStatusBadgeProps } from "../common/status-badge/BadgeType";
import { patientService } from "../../services/medicationmanagement/patientApi/PatientApi";

const badgeprops: IStatusBadgeProps = {
    type: BadgeType.Info,
    width: "fit-content",
    name: "Chart reviewed"
};
const dialogprops: IDialogBoxProps = {
    title: "Acknowledge chart review",
    content: `Are you sure you want to acknowledge the new chart expiry?`,
};
const actionErrorDialogprops: IOKDialogBoxProps = {
    title: "There was a problem marking this change as actioned",
    content: `We have experienced an issue marking the chart review as actioned. Please try again.`,
};
const confirmErrorDialogprops: IOKDialogBoxProps = {
    title: "There was a problem confirming changes",
    content: `We have experienced an issue confirming the chart review. Please try again.`,

};
export const ResidentChartReview = (props: {
    dispatch: React.Dispatch<any>,
    state: boolean,
    handleOnChartReviewConfirmed: (val: boolean) => void,
    patient: any
}) => {
    const [actionError, setActionError] = useState(false);
    const [actionConfirmed, setActionConfirmed] = useState(false);
    const [actionConfirmationError, setActionConfirmationError] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const saveChartReviewAction = (lastPharmacyMedicationOrderId: any, val: any, isConfirmed: boolean = false) => {
        patientService.saveChartReviewAction(lastPharmacyMedicationOrderId, val, isConfirmed)
        .then(res => {
            setActionError(!res);
            if(res){
                if(!isConfirmed){
                    setShowConfirmationDialog(true);
                }
                else{
                    props.handleOnChartReviewConfirmed(true);
                }
                
            }
        })
        .catch(err => setActionError(true));
    }

    useEffect(() => {
        if (props.state) { // checkbox click
            saveChartReviewAction(props.patient.lastPharmacyMedicationOrderId, props.state);          
        }
    }, [props.state])

    const handleOnChartReviewConfirmed = async (value: boolean) => {
        setActionConfirmed(value);
        
        if (!value) { // cancel
            saveChartReviewAction(props.patient.lastPharmacyMedicationOrderId, value);
        } else { // confirm
             await patientService.saveChartReviewConfirmation(props.patient.lastPharmacyMedicationOrderId)
                .then(res => {
                    setActionConfirmationError(!res);
                    if (res == true) {
                        saveChartReviewAction(props.patient.lastPharmacyMedicationOrderId, true, true);
                    }
                })
                .catch(err => setActionConfirmationError(true));
        }
    }

    return (<>
            <StatusBadgeCheckbox
                IStatusBadgeProps={badgeprops} dispatch={props.dispatch} state={props.state} kind={BadgeVariant.Success}
            />

        {actionError &&
            <ErrorDialogBox dialogBoxProps={actionErrorDialogprops} dispatch={props.dispatch} state={props.state}
                onactionedConfirmed={handleOnChartReviewConfirmed}
            /> }
        {showConfirmationDialog && <DialogBox dialogBoxProps={dialogprops} dispatch={props.dispatch} state={props.state}
                onactionedConfirmed={handleOnChartReviewConfirmed} />
        }
        {actionConfirmationError && <ErrorDialogBox dialogBoxProps={confirmErrorDialogprops} dispatch={props.dispatch} state={actionConfirmed}
            onactionedConfirmed={handleOnChartReviewConfirmed} />}
    </>
    );
};
